module.exports = __webpack_public_path__ + "media/images/service-logo-0dad64ba3d2cd7978e84196f42312ae3.png";